import { render, staticRenderFns } from "./WineShow_Desktop.vue?vue&type=template&id=48f665a8&scoped=true&"
import script from "./WineShow_Desktop.vue?vue&type=script&lang=js&"
export * from "./WineShow_Desktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f665a8",
  null
  
)

export default component.exports